function formatCellphone(rawNumber) {
    var substringStart = 2;

    if (rawNumber.startsWith("0")) {
        substringStart++;
    }

    return "(" + rawNumber.substring(0, substringStart) + ") " +
        rawNumber.substring(substringStart, substringStart + 1) + " " +
        rawNumber.substring(substringStart + 1, substringStart + 5) + "-" +
        rawNumber.substring(substringStart + 5);
}

function formatLandLinePhone(rawNumber) {
    var substringStart = 2;

    if (rawNumber.startsWith("0")) {
        substringStart++;
    }

    return "(" + rawNumber.substring(0, substringStart) + ") " +
        rawNumber.substring(substringStart, substringStart + 4) + "-" +
        rawNumber.substring(substringStart + 4);
}

function formatDDDPrefix(rawNumber) {
    if (!/^\d{3}$/.test(rawNumber)) {
        throw new Error("O número de DDD do celular não está no formato esperado.");
    }

    return rawNumber.substring(1);
}

function fixDDDonMask(field, phonePatterns) {
    const datasetDDD           = field.data("phoneddd");
    const { mobile, landline } = phonePatterns;

    if (!datasetDDD) return;
    const value      = field.val().replace(/\D/g, "");
    // eslint-disable-next-line radix
    const firstDigit = parseInt(value.substring(0, 2));

    if (field.val().length <= 4) {
        const datasetDDDString = datasetDDD.toString();
        let DDDMasked = $('<input type="text">').val(datasetDDDString).mask(mobile).masked(datasetDDDString);
        DDDMasked += ')'
        field.val(DDDMasked);
        return DDDMasked;
    }

    if (!isNaN(firstDigit) && firstDigit !== datasetDDD) {
        const valueWithDDD = `${datasetDDD}${value}`;
        let numberMasked = $('<input type="text">').val(valueWithDDD).mask(isCellphoneNumber(valueWithDDD || "") ? mobile : landline).masked(valueWithDDD);
        field.val(numberMasked);
        return numberMasked;
    }
}

function getThirdDigitOfPhone(maskedNumber) {
    //Remove the mask special characters to get the accurate length of the phone number string.
    const unmaskedValue  = maskedNumber.replace(/\D/g, "") || "";

    return unmaskedValue.length >= 3 ? unmaskedValue.charAt(2) : "";
}

function isCellphoneNumber(maskedNumber) {
    const thirdCharacter = getThirdDigitOfPhone(maskedNumber);

    return thirdCharacter === "9";
}

function isValidPhoneNumber(phoneNumber, cellphoneFormatOnly, landlineFormatOnly) {
    if (cellphoneFormatOnly && !isCellphoneNumber(phoneNumber)) {
        return false;
    }

    if (landlineFormatOnly && isCellphoneNumber(phoneNumber)) {
        return false;
    }

    // If it starts with 9, it should be a cellphone number (99) 9 9999-9999, otherwise it is a landline number (99) 9999-9999.
    return isCellphoneNumber(phoneNumber) ? phoneNumber.length === 15 : phoneNumber.length === 14;
}

/**
* Returns a JSON object from a given string or object
* @param {Object|string} jsonObject - the JSON object or stringified JSON
* @returns {Object} - the JSON object
*/
function getOrParseJson(jsonObject) {
    try {
        return jsonObject && (typeof jsonObject === "object" ? jsonObject : JSON.parse(jsonObject));
    } catch (error) {
        return null;
    }
}

function addLeftZero(number) {
    return ("0" + String(number)).slice(-2);
}

function adjustTimezone(date, timezone) {
    const currentOffset    = date.getTimezoneOffset();
    const targetOffset     = (timezone * 60);
    const offsetDifference = (currentOffset + targetOffset) * 60 * 1000;

    date.setTime(date.getTime() + offsetDifference);

    return date;
}

function formatPeriodTime(period, time) {
    function formatTime(time) {
        const formated = time.split(":").reduce((acc, value, index) => {
            if (index > 0) {
                const parsedValue = parseInt(value, 10);

                acc += parsedValue > 0 ? ":" + value : "";
            } else {
                acc += value;
            }

            return acc;
        }, "");

        return formated + "h";
    }

    const [timeStart, timeEnd] = time.split("-");

    return period + " - " + formatTime(timeStart) + " às " + formatTime(timeEnd);
}

function formatDate(date, format) {
    var WEEK_DAYS = [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado"
    ];

    const year         = date.getFullYear();
    const weekDay      = date.getDay();
    const month        = addLeftZero(date.getMonth() + 1);
    const day          = addLeftZero(date.getDate());
    const hours        = addLeftZero(date.getHours());
    const minutes      = addLeftZero(date.getMinutes());
    const seconds      = addLeftZero(date.getSeconds());
    const milliseconds = date.getMilliseconds();

    return format
        .replace("yyyy", year)
        .replace("MM", month)
        .replace("dd", day)
        .replace("HH", hours)
        .replace("mm", minutes)
        .replace("ss", seconds)
        .replace("SSS", milliseconds)
        .replace("DD", WEEK_DAYS[weekDay]);
}

module.exports = {
    formatCellphone     : formatCellphone,
    formatLandLinePhone : formatLandLinePhone,
    isValidPhoneNumber  : isValidPhoneNumber,
    isCellphoneNumber   : isCellphoneNumber,
    getOrParseJson      : getOrParseJson,
    formatDDDPrefix     : formatDDDPrefix,
    fixDDDonMask        : fixDDDonMask,
    formatDate          : formatDate,
    formatPeriodTime    : formatPeriodTime,
    adjustTimezone      : adjustTimezone
};
